export default {
  title: 'Log in with your username',
  submit: 'Log In',
  linkForgot: 'Forgot password?',
  placeholder: {
    username: 'Username',
    password: 'Password',
  },
  errors: {},
};
